import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSiteJsPermission = () =>
  produce((draft: Draft<State>) => {
    draft.siteJsPermission.fetching = draft.siteJsPermission.fetching + 1;
  });

export const setSiteJsPermission = (siteJsPermission: boolean) =>
  produce((draft: Draft<State>) => {
    draft.siteJsPermission.data = siteJsPermission;
  });

export const finishFetchingSiteJsPermission = () =>
  produce((draft: Draft<State>) => {
    draft.siteJsPermission.fetching = draft.siteJsPermission.fetching - 1;
  });

export const disposeSiteJsPermission = () =>
  produce((draft: Draft<State>) => {
    draft.siteJsPermission.data = initialState.siteJsPermission.data;
    draft.siteJsPermission.fetching = initialState.siteJsPermission.fetching;
  });
